/* eslint-disable arrow-body-style */
import type { FC, Ref } from "react";
import { isEmpty, mergeClasses } from "@huub-web/utils";

import type { TimelineRecord } from "../Timeline";
import { Flex } from "../../Flex/Flex";
import { containerStyle } from "./TimelineEntry.css";
import { Text } from "../../Text/Text";
import { useFormattedDate } from "../../../hooks/useFormattedDate";
import { ValueParser } from "../../ValueParser/ValueParser";

export type TimelineEntryProps = {
  record: TimelineRecord;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

export const TimelineEntry: FC<TimelineEntryProps> = ({
  record,
  ref,
  ...props
}) => {
  const { formatDate } = useFormattedDate();

  return (
    <Flex
      ref={ref}
      className={mergeClasses(containerStyle)}
      direction="column"
      gap="xxs2"
      {...props}
    >
      {record.subtitle && (
        <Text variant="bodyS" color="currentColor50">
          {record.subtitle}
        </Text>
      )}
      {record.date && <Text>{formatDate(record.date)}</Text>}
      <Flex gap="xxs" align="baseline">
        <Text variant="bodyL">{record.title}</Text>
        {record.trailing && <Flex>{record.trailing}</Flex>}
        {!isEmpty(record.percentage) && record.percentage !== undefined && (
          <Text
            color={record.percentage > 0 ? "success" : "error"}
            variant="bodyS"
          >
            <ValueParser
              value={{ type: "percentage", value: record.percentage }}
            />
          </Text>
        )}
      </Flex>
      {record.description && (
        <Text variant="bodyS" color="currentColor50">
          {record.description}
        </Text>
      )}
    </Flex>
  );
};
